import { useCallback, useRef } from 'react';
import { SECONDS } from '../constant/constant';
import type { TimeFormatT } from '../types/types';
import { getFormattedTime } from '../utils/utils';
const useActionDuration = (format: TimeFormatT = SECONDS) => {
  const timer = useRef<Date>(new Date());
  const start = useCallback(() => {
    timer.current = new Date();
  }, []);
  const end = useCallback(() => {
    const endTime = new Date();
    // @ts-expect-error todo(ts-migration) TS2362 The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const diffTime = endTime - timer.current;
    return getFormattedTime(diffTime, format);
  }, [format]);
  return {
    start,
    end
  };
};
export default useActionDuration;